import React from 'react';
import DashboardLayout from '../DashboardLayout';

const ClientLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default ClientLayout;
